module.exports = __webpack_public_path__ + "static/media/1216.d0289dc0.png";